import React from 'react';
import './style.scss';
import { DeliveryAvailability } from './sddTypes';
import SddTile from './SddTile';
import { checkIfCustomer } from 'src/scripts/utils/helpers';
import { SiteSettings } from 'src/scripts/utils/environment';
import { formatCutoffTime, getSddTileProps } from './sddUtils';
import { customerLocationState } from '../StoreLocator/customerLocationState';
import { formatShopifyPrice } from 'src/scripts/sections/header/Cart/components/helpers';

const shippingDataFromMF = SiteSettings?.sddShippingOptions;
const isSignedIn = checkIfCustomer();
const customerLoyaltyTier = isSignedIn && window.getCustomerInfo ? window?.getCustomerInfo().loyalty_tier : '';

const SddContainer = ({
  shippingInfoFromOMS,
  hasLuxuryTag,
}: {
  shippingInfoFromOMS: DeliveryAvailability | null;
  hasLuxuryTag: boolean;
}) => {
  const title =
    shippingInfoFromOMS?.sdd_type.toLowerCase() === 'nextday_delivery' ? 'Next Day Delivery' : 'Same Day Delivery';
  const tileText = `Orders placed after ${
    shippingInfoFromOMS?.cutoff_time
      ? formatCutoffTime(shippingInfoFromOMS.cutoff_time)
      : shippingInfoFromOMS?.cutoff_time
  } local time will be delivered next day.`;

  const isShippingOptionEligible = (option: SddShippingOption): boolean => {
    const shippingService = option.service.toLowerCase();
    switch (shippingService) {
      case 'loyalty':
        return customerLoyaltyTier === 'tier2' || customerLoyaltyTier === 'tier3';
      case 'express':
        return customerLoyaltyTier === 'tier1' || !isSignedIn;
      default:
        return true; // show other types
    }
  };

  return (
    <>
      {shippingInfoFromOMS ? (
        <div className="sdd-oms-tile">
          <SddTile
            key={shippingInfoFromOMS?.sdd_type}
            title={title}
            price={formatShopifyPrice(Number(shippingInfoFromOMS?.total_price) || 0)}
            tileText={tileText}
          />
        </div>
      ) : customerLocationState.sddZip ? (
        <div className="not-available-tile">
          <SddTile
            key="sdd_unavailable"
            title="Same Day Delivery"
            price={''}
            tileText="Not eligible for your selection"
          />
        </div>
      ) : null}
      <div className="sdd-metafield-tiles">
        {shippingDataFromMF &&
          shippingDataFromMF.shippingOptions.filter(isShippingOptionEligible).map((option) => {
            const { price, tileText, title } = getSddTileProps(option, hasLuxuryTag);
            return <SddTile key={option.service} title={title} price={price} tileText={tileText} />;
          })}
      </div>
    </>
  );
};

export default SddContainer;
